import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  daySunday: { id: 'day-hour-heatmap.day-sunday', defaultMessage: 'Sun' },
  dayMonday: { id: 'day-hour-heatmap.day-monday', defaultMessage: 'Mon' },
  dayTuesday: { id: 'day-hour-heatmap.day-tuesday', defaultMessage: 'Tue' },
  dayWednesday: { id: 'day-hour-heatmap.day-wednesday', defaultMessage: 'Wed' },
  dayThursday: { id: 'day-hour-heatmap.day-thursday', defaultMessage: 'Thu' },
  dayFriday: { id: 'day-hour-heatmap.day-friday', defaultMessage: 'Fri' },
  daySaturday: { id: 'day-hour-heatmap.day-saturday', defaultMessage: 'Sat' },
});

export const DAY_HEADER_MESSAGES = [
  messages.daySunday,
  messages.dayMonday,
  messages.dayTuesday,
  messages.dayWednesday,
  messages.dayThursday,
  messages.dayFriday,
  messages.daySaturday,
];
